import { render, staticRenderFns } from "./Natverksterminologi.vue?vue&type=template&id=4aeed544&scoped=true&"
import script from "./Natverksterminologi.vue?vue&type=script&lang=js&"
export * from "./Natverksterminologi.vue?vue&type=script&lang=js&"
import style0 from "./Natverksterminologi.vue?vue&type=style&index=0&id=4aeed544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeed544",
  null
  
)

export default component.exports